YUI.add('subset-search', function (Y) {

"use strict";

var name, url;


/* SubsetSearch class constructor */
var SubsetSearch = function(config) {

    SubsetSearch.superclass.constructor.apply(this, arguments);

};

/*
 * Required NAME static field, to identify the class and
 * used as an event prefix, to generate class names etc. (set to the
 * class name in camel case).
 */
SubsetSearch.NAME = "SubsetSearch";

/*
 * Required NS static field, to identify the property on the host which will,
 * be used to refer to the plugin instance ( e.g. host.feature.doSomething() )
 */
SubsetSearch.NS = "subsetSearch";

/*
 * The attribute configuration for the plugin. This defines the core user facing state of the plugin
 */
SubsetSearch.ATTRS = {};

/* SubsetSearch extends the base Plugin.Base class */
Y.extend(SubsetSearch, Y.Plugin.Base, {

    initializer: function(config) {

        console.log("Initializing", this.name);

        // If there is no site name or site URL to use for subsetting, abort early.
        if (!KSU || !KSU.config) {
            return;
        }

        name = KSU.config.searchName;
        url = KSU.config.searchUrl;
        if (!name || !url) {
            return;
        }

        config.host.on('submit', this.submit);

        /* This is cheating a little, because this plugin is affecting the DOM outside of the element it is plugged into.
         * Specifically, this plugin is plugged into the search form that starts a search.  On wide pages, the form
         * appears, and everything is OK.  However, on narrow pages, the search form is hidden and a simple link
         * to the search engine is used.  This code overrides the URL to include the subset search name and URL,
         * even though the link is outside the form.
         */
        Y.all("#ksu-search-block>a").set('href', '//search.k-state.edu?' +
           'subsitename=' + encodeURIComponent(name) + '&subseturl=' + encodeURIComponent(url));

        console.log("initialization complete", this.name);
    },

    submit: function() {

        // Unless the hidden field which holds the name already exists, add both it and the corresponding URL field.
        // They are always added in pairs, so it is OK to test for one, but add both.
        if (name && !this.one("input[name='subsitename']")) {
            this.append("<input type='hidden' name='subsitename' value='" + Y.Escape.html(name) +
                      "'><input type='hidden' name='subsiteurl' value='" + Y.Escape.html(url) + "'>");
        }

    }

});

Y.namespace("Plugin").SubsetSearch = SubsetSearch;

}, '2.0.0', {"requires": ["node", "base", "plugin", "escape"]});
